<template>
  <div class="screens-wrapper">
    <Warranty
      v-if="!isSubstep"
      :order="order"
      @updateOrderStep="(token, params) => updateOrderStep(token, params, '2b')"
      :edit-mode="editMode"
    />
    <FridayWarranty
      v-if="isSubstep"
      :order="order"
      @updateOrderStep="(token, params) => updateOrderStep(token, params, '3')"
      :edit-mode="editMode"
    />
  </div>
</template>

<script>
import Warranty from '@/components/Warranty';
import FridayWarranty from '@/components/FridayWarranty';

export default {
  components: {
    Warranty,
    FridayWarranty,
  },
  props: [
    'car',
    'order',
    'startOrderProcess',
    'updateOrderStep',
    'currentOrderStep',
    'isSubstep',
    'orderCreationError',
    'orderCreationErrorDetails',
    'editMode'
  ],
};
</script>
